import React from 'react';
import { useRoleSelectListQuery } from 'api';
import { Select, SelectProps } from 'components';

export const RoleSelect: React.FC<SelectProps> = React.memo((props) => {
  const { data = [] } = useRoleSelectListQuery();

  return (
    <Select
      options={data}
      showSearch
      filterOption={(input, option) => option?.label?.toString().toLowerCase().includes(input.toLowerCase()) ?? false}
      {...props}
    />
  );
});
